import { faCheck, faSignOutAlt, faSyncAlt, faTimes } from '@fortawesome/pro-regular-svg-icons';

export default {
  data () {
    return {
      dataAddIcon: faCheck,
      dataCloseIcon: faTimes,
      dataExitIcon: faSignOutAlt,
      dataRefreshIcon: faSyncAlt
    };
  }
};
